// removed by extract-text-webpack-plugin
module.exports = {"appLogo":"Logo__appLogo__1owlH","appLogoFixedSize":"Logo__appLogoFixedSize__3a9g9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Logo/Logo.css
// module id = 282
// module chunks = 0